import humanizeDuration from "humanize-duration";
import { useRouteUtils } from "./route";

export function useTime() {
  /**
   * Makes a human duration string based on the current locale
   * @param duration The duration to humanise in ms
   */
  function humanDuration(duration: number) {
    const { locale } = useRouteUtils();

    return humanizeDuration(Math.ceil(duration / 1000) * 1000, { language: locale.value });
  }

  return { humanDuration };
}
